<template lang="html">
  <root>

    <!-- Nav -->
    <nav>
      <div class="nav-wrapper">
        <router-link :to="{ name: 'Dashboard' }" class="brand-logo">Awani</router-link>
        <ul class="right hide-on-med-and-down">
          <li class="tooltipped" data-position="bottom" data-tooltip="Users">
            <router-link :to="{ name: 'Users' }"><i class="material-icons">group</i></router-link>
          </li>
          <li class="b tooltipped" data-position="bottom" data-tooltip="Businesses">
            <router-link :to="{ name: 'Businesses', params: { lang: businessesLang } }"><i class="material-icons">restaurant</i></router-link>
          </li>
          <li class="tooltipped" data-position="bottom" data-tooltip="Dishes">
            <router-link :to="{ name: 'Dishes', params: { lang: dishesLang } }"><i class="material-icons">restaurant_menu</i></router-link>
          </li>
          <li class="tooltipped" data-position="bottom" data-tooltip="Instant dishes">
            <router-link :to="{ name: 'InstantDishes' }"><i class="material-icons">whatshot</i></router-link>
          </li>
          <li class="tooltipped" data-position="bottom" data-tooltip="Orders">
            <router-link :to="{ name: 'Orders' }"><i class="material-icons">shopping_cart</i></router-link>
          </li>
          <li data-activates="slide-out" class="sidenav-trigger">
            <a><i class="material-icons">more_vert</i></a>
          </li>
        </ul>
      </div>
    </nav>

    <!-- Sidenav -->
    <ul id="slide-out" class="side-nav">
      <li>
        <img src="../../../assets/logo.png" alt="">
        <h4>Awani admin</h4>
        <p>admin@awaniapp.com</p>
      </li>
      <li><div class="divider"></div></li>
      <li @click="countriesRouter"><a><i class="material-icons">public</i>Countries</a></li>
      <li @click="citiesRouter"><a><i class="material-icons">place</i>Cities</a></li>
      <li @click="verificationsRouter"><a><i class="material-icons">mobile_friendly</i>Verifications</a></li>
      <li @click="pushNotificationsRouter"><a><i class="material-icons">textsms</i>Push notification</a></li>
      <li @click="configurationsRouter"><a><i class="material-icons">settings</i>Configurations</a></li>
      <li @click="passwordUpdateRouter"><a><i class="material-icons">lock</i>Update password</a></li>
      <li @click="signOut"><a><i class="material-icons">exit_to_app</i>Sign out</a></li>
    </ul>

  </root>
</template>

<script>
import * as firebase from 'firebase'

export default {
  data() {
    return {
      businessesLang: 'en',
      dishesLang: 'en'
    }
  },

  methods: {

    // Sign out
    signOut() {
      firebase.auth().signOut()
      this.hideSideBar()
      Materialize.toast('Successfully signed out', 4000)
      this.$router.push({ name: 'Home' })
    },

    // Hide sidebar
    hideSideBar() {
      $('.sidenav-trigger').sideNav('hide');
    },

    // Routers
    citiesRouter() {
      this.hideSideBar()
      this.$router.push({ name: 'Cities' })
    },

    countriesRouter() {
      this.hideSideBar()
      this.$router.push({ name: 'Countries' })
    },

    passwordUpdateRouter() {
      this.hideSideBar()
      this.$router.push({ name: 'PasswordUpdate' })
    },

    configurationsRouter() {
      this.hideSideBar()
      this.$router.push({ name: 'Configurations' })
    },

    pushNotificationsRouter() {
      this.hideSideBar()
      this.$router.push({ name: 'PushNotifications' })
    },

    verificationsRouter() {
      this.hideSideBar()
      this.$router.push({ name: 'Verifications' })
    },

    collectLangs() {
      var businessesLang = localStorage.getItem('businesses_lang')
      this.businessesLang = businessesLang == 'undefined' ? 'en' : businessesLang

      var dishesLang = localStorage.getItem('dishes_lang')
      this.dishesLang = dishesLang == 'undefined' ? 'en' : dishesLang
    }
  },

  // Mounted
  mounted() {
    $('.tooltipped').tooltip()
    $(".sidenav-trigger").sideNav();
    this.collectLangs()
  }
}
</script>

<style lang="scss">
@import '../../../theme';

nav {
  padding-left: 15px;
  background-color: $theme-color !important;

  .brand-logo {
    text-transform: uppercase;
    font-size: 17px !important;
  }
}

.side-nav {

  li:first-child {
    background: #f6f6f6;
    padding-top: 20px;
    padding-bottom: 15px;
  }

  img {
    width: 75px;
    height: auto;
    display: block;
    margin: auto;
    border-radius: 50px;
  }

  h4 {
    text-transform: uppercase;
    font-size: 15px;
    font-weight: bold;
    text-align: center;
    margin-top: 24px;
    margin-bottom: 0;
  }

  p {
    margin: 0;
    text-align: center;
    color: #888;
    font-size: 13px;
    line-height: 3em;
  }

  .divider {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Partial/Nav.vue